import React, { useState } from "react";
import SharingWidget from "./components/SharingWidget";
import { ChevronRightIcon } from "@radix-ui/react-icons";

export default ({
  orgName,
  applyUrl,
  job,
  colorHeaderText,
  colorButtonBg,
  colorButtonText,
  permalink,
  tabs,
  canApply
}) => {
  const [showSharing, setShowSharing] = useState(false);

  return (
    <>
      <div className="flex items-center">
        <h1
          className="text-2xl font-semibold md:text-3xl pt-2 md:pt-0 grow"
          style={{ color: colorHeaderText }}
        >
          {job.name}
        </h1>
        {canApply && (
          <div className="shrink hidden md:flex gap-x-2">
            <a
              href={applyUrl}
              className="grow text-base py-2.5 rounded-lg font-medium shadow-xs flex justify-center items-center space-x-2 w-64"
              style={{
                color: colorButtonText,
                backgroundColor: colorButtonBg
              }}
            >
              Apply Now <ChevronRightIcon className="h-5 w-5 inline-block" />
            </a>
            <div
              className="cursor-pointer text-center border-2 text-base py-2.5 px-3 rounded-lg font-medium shadow-xs shrink w-24"
              style={{
                color: colorButtonBg,
                borderColor: colorButtonBg,
                backgroundColor: colorButtonText
              }}
              onClick={(e) => {
                if (e) e.preventDefault();
                setShowSharing(!showSharing);
              }}
            >
              Share
            </div>
          </div>
        )}
      </div>
      <div className="block md:hidden mb-3 mt-2 flex gap-x-2">
        {canApply && (
          <>
            <a
              href={applyUrl}
              className="text-base py-2.5 rounded-lg font-medium shadow-xs block grow flex justify-center items-center space-x-2"
              style={{ color: colorButtonText, backgroundColor: colorButtonBg }}
            >
              Apply Now <ChevronRightIcon className="h-5 w-5 inline-block" />
            </a>

            <div
              className="text-center border-2 text-base py-2.5 px-3 rounded-lg font-medium shadow-xs block shrink"
              style={{
                color: colorButtonBg,
                borderColor: colorButtonBg,
                backgroundColor: colorButtonText
              }}
            >
              <div
                className="cursor-pointer inline-flex relative items-center"
                style={{ color: colorHeaderText }}
                onClick={(e) => {
                  if (e) e.preventDefault();
                  setShowSharing(true);
                }}
              >
                Share
              </div>
            </div>
          </>
        )}
      </div>

      {showSharing && (
        <>
          <div
            className=""
            onClick={(e) => {
              if (e) {
                e.preventDefault();
                e.stopPropagation();
              }
              setShowSharing(!showSharing);
            }}
          />
          <div className="text-sm whitespace-nowrap flex justify-center md:justify-end -mt-2 md:mt-2">
            <SharingWidget
              title={`Job Post: ${orgName} - ${job.name}`}
              description=""
              permalink={permalink}
            />
          </div>
        </>
      )}

      {tabs.length > 0 && (
        <select
          onChange={(e) => {
            window.location.href = `#${e.target.value}`;
          }}
          id="tabs"
          name="tabs"
          className="block md:hidden w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 mb-4"
        >
          {tabs.map(({ name, id }) => (
            <option key={id || name} value={id}>
              {name}
            </option>
          ))}
        </select>
      )}
    </>
  );
};
